import React from 'react'
import { Col, Grid, Row } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import CountryWarnings from '../CountryWarnings'
import AmbassadorStatusChange from '../../StatusChange/AmbassadorStatusChange'
import { AmbassadorSection } from '../../../../../../Components/City/Page/Ambassador/AmbassadorSection'
import { SectionTitle } from '../../../../../../Components/Section/SectionTitle'
import { LinkExternal } from '../../../../../../Components/LinkExternal'
import StyledIconButton from '../../../../../../Components/Form/StyledIconButton'
import EditIcon from '@material-ui/icons/Edit'

const IdentificationFilesSection = ({
  ambassador,
  ambassadorDocuments,
  cities,
  isFadeLoading,
  fade,
  onFadeChange,
  handleUserActions,
}) => {
  const history = useHistory()
  let countryCode
  let status

  if (cities.length > 0) {
    let city = cities.find(cities => ambassador.city.id === cities.id)
    countryCode = city.country.countryCode
  }

  if (ambassador && ambassador.status === 'waiting_for_review') {
    status = true
  } else {
    status = false
  }

  return (
    <AmbassadorSection>
      <Grid fluid>
        <Row>
          <Col xs={12}>
            <SectionTitle>Identification Files</SectionTitle>
            <StyledIconButton
              style={{ float: 'right' }}
              onClick={() =>
                history.push(history.location.pathname + '/upload-documents')
              }
            >
              <EditIcon />
            </StyledIconButton>
          </Col>
        </Row>
        {ambassadorDocuments.length ? (
          <div>
            <Row>
              {ambassadorDocuments.map(doc => (
                <Col xs={3} key={doc.id}>
                  <p className="col-title">ID Prof {doc.id}</p>
                  <LinkExternal href={doc.url} target="_blank">
                    Click here
                  </LinkExternal>
                </Col>
              ))}
            </Row>
          </div>
        ) : (
          <p>no files available</p>
        )}

        <CountryWarnings country={countryCode} status={status} />

        <AmbassadorStatusChange
          ambassadorStatus={ambassador.status}
          onChange={handleUserActions}
          onFadeChange={onFadeChange}
          fade={fade}
          disabled={!!ambassador.isLoading || isFadeLoading}
        />
      </Grid>
    </AmbassadorSection>
  )
}

export default IdentificationFilesSection



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasador/Components/IdentificationFilesSection/index.js